export default "__VITE_ASSET__DNzAM$vu__"